export default __webpack_public_path__ + "static/media/partners4.6e814aca.png";